// extracted by mini-css-extract-plugin
export default {"cell":"PayDateCell_cell__8P390"};